var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_205_161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#paint0_linear_205_161)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_205_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C13.2708 27.5 11.6458 27.1719 10.125 26.5156C8.60417 25.8594 7.28125 24.9688 6.15625 23.8438C5.03125 22.7188 4.14063 21.3958 3.48438 19.875C2.82812 18.3542 2.5 16.7292 2.5 15C2.5 13.2708 2.82812 11.6458 3.48438 10.125C4.14063 8.60417 5.03125 7.28125 6.15625 6.15625C7.28125 5.03125 8.60417 4.14063 10.125 3.48438C11.6458 2.82812 13.2708 2.5 15 2.5C16.7292 2.5 18.3542 2.82812 19.875 3.48438C21.3958 4.14063 22.7188 5.03125 23.8438 6.15625C24.9688 7.28125 25.8594 8.60417 26.5156 10.125C27.1719 11.6458 27.5 13.2708 27.5 15C27.5 16.7292 27.1719 18.3542 26.5156 19.875C25.8594 21.3958 24.9688 22.7188 23.8438 23.8438C22.7188 24.9688 21.3958 25.8594 19.875 26.5156C18.3542 27.1719 16.7292 27.5 15 27.5ZM13.75 24.9375V22.5C13.0625 22.5 12.474 22.2552 11.9844 21.7656C11.4948 21.276 11.25 20.6875 11.25 20V18.75L5.25 12.75C5.1875 13.125 5.13021 13.5 5.07812 13.875C5.02604 14.25 5 14.625 5 15C5 17.5208 5.82812 19.7292 7.48438 21.625C9.14062 23.5208 11.2292 24.625 13.75 24.9375ZM22.375 21.75C22.7917 21.2917 23.1667 20.7969 23.5 20.2656C23.8333 19.7344 24.1094 19.1823 24.3281 18.6094C24.5469 18.0365 24.7135 17.4479 24.8281 16.8438C24.9427 16.2396 25 15.625 25 15C25 12.9583 24.4323 11.0938 23.2969 9.40625C22.1615 7.71875 20.6458 6.5 18.75 5.75V6.25C18.75 6.9375 18.5052 7.52604 18.0156 8.01562C17.526 8.50521 16.9375 8.75 16.25 8.75H13.75V11.25C13.75 11.6042 13.6302 11.901 13.3906 12.1406C13.151 12.3802 12.8542 12.5 12.5 12.5H10V15H17.5C17.8542 15 18.151 15.1198 18.3906 15.3594C18.6302 15.599 18.75 15.8958 18.75 16.25V20H20C20.5417 20 21.0312 20.1615 21.4688 20.4844C21.9062 20.8073 22.2083 21.2292 22.375 21.75Z",
    fill: "url(#paint1_linear_205_161)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_161",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_161",
    x1: 15,
    y1: 2.5,
    x2: 15,
    y2: 27.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicBlue);
export default __webpack_public_path__ + "static/media/public_blue.a637bc675d57559ebecb305209e27b8f.svg";
export { ForwardRef as ReactComponent };